export default {
	ADD_IMAGE: 'ADD_IMAGE',
	REMOVE_IMAGE: 'REMOVE_IMAGE',
	ADD_ITEM: 'ADD_ITEM',
	ADD_ITEMS: 'ADD_ITEMS',
	REMOVE_ITEM: 'REMOVE_ITEM',
	DUPLICATE_ITEM: 'DUPLICATE_ITEM',
	INCREASE_ITEM_QUANTITY: 'INCREASE_PRODUCT_QUANTITY',
	DECREASE_ITEM_QUANTITY: 'DECREASE_PRODUCT_QUANTITY',
	RESET_ITEM_OPTIONS: 'RESET_ITEM_OPTIONS',
	CANCEL_ITEM_CHANGES: 'CANCEL_ITEM_CHANGES',
	SET_ITEM_QUANTITY: 'SET_PRODUCT_QUANTITY',
	SET_ORDER_ITEM_PRODUCT: 'SET_ORDER_ITEM_PRODUCT',
	SET_ITEM_IMAGE_FILTER: 'SET_ITEM_IMAGE_FILTER',
	SET_LOW_RES_WARNING: 'SET_LOW_RES_WARNING',
	SET_LOW_RES_WARNING_OVERRIDE: 'SET_LOW_RES_WARNING_OVERRIDE',
	SET_AUTO_CROP_WARNING_OVERRIDE: 'SET_AUTO_CROP_WARNING_OVERRIDE',
	REMOVE_LOW_RES_WARNING: 'REMOVE_LOW_RES_WARNING',
	SET_AUTO_CROP_WARNING: 'SET_AUTO_CROP_WARNING',
	TOGGLE_BATCH_SELECTION: 'TOGGLE_BATCH_SELECTION',
	TOGGLE_ITEM_BATCH_STATE: 'TOGGLE_ITEM_BATCH_STATE',
	ROTATE_IMAGE: 'ROTATE_IMAGE',
	SET_CROP_POSITION_SCALE: 'SET_CROP_POSITION_SCALE',
	SET_CROP_SCALE: 'SET_CROP_SCALE',
	SET_ITEM_IMAGE_TAKEN_DATE: 'SET_ITEM_IMAGE_TAKEN_DATE',
	REMOVE_ITEMS_BY_IMAGEID: 'REMOVE_ITEMS_BY_IMAGEID',
	SET_ITEM_LABEL: 'SET_ITEM_LABEL',
	SET_ORDER_ITEM_UPLOAD_STATUS: 'SET_ORDER_ITEM_UPLOAD_STATUS',
	SET_CROP_LOWRES_WARNING_SEEN: 'SET_CROP_LOWRES_WARNING_SEEN'
};
